module.exports = __webpack_public_path__ + "static/media/estampagem.9ed1e2f4.jpg";